const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 64;

function normalizeValues(values) {
  return {
    currentPassword: String(values.currentPassword ?? ''),
    newPassword: String(values.newPassword ?? ''),
    confirmPassword: String(values.confirmPassword ?? ''),
  };
}

function hasMixedCase(value) {
  return /[a-z]/.test(value) && /[A-Z]/.test(value);
}

function hasNumber(value) {
  return /\d/.test(value);
}

function hasSpecialCharacter(value) {
  return /[^A-Za-z0-9]/.test(value);
}

function resolveRuleStatus({ active, valid }) {
  if (!active) {
    return 'pending';
  }

  return valid ? 'met' : 'unmet';
}

export function getAccountSecurityRequirements(values) {
  const { currentPassword, newPassword, confirmPassword } = normalizeValues(values);
  const hasNewPassword = newPassword.length > 0;

  return [
    {
      id: 'minLength',
      label: `Al menos ${MIN_PASSWORD_LENGTH} caracteres`,
      status: resolveRuleStatus({
        active: hasNewPassword,
        valid: newPassword.length >= MIN_PASSWORD_LENGTH,
      }),
    },
    {
      id: 'mixedCase',
      label: 'Incluye mayúsculas y minúsculas',
      status: resolveRuleStatus({
        active: hasNewPassword,
        valid: hasMixedCase(newPassword),
      }),
    },
    {
      id: 'number',
      label: 'Incluye al menos un número',
      status: resolveRuleStatus({
        active: hasNewPassword,
        valid: hasNumber(newPassword),
      }),
    },
    {
      id: 'specialCharacter',
      label: 'Incluye al menos un carácter especial',
      status: resolveRuleStatus({
        active: hasNewPassword,
        valid: hasSpecialCharacter(newPassword),
      }),
    },
    {
      id: 'differentFromCurrent',
      label: 'Debe ser distinta a la actual',
      status: resolveRuleStatus({
        active: hasNewPassword && currentPassword.length > 0,
        valid: newPassword !== currentPassword,
      }),
    },
    {
      id: 'confirmPassword',
      label: 'Coincide con la confirmación',
      status: resolveRuleStatus({
        active: confirmPassword.length > 0,
        valid: hasNewPassword && newPassword === confirmPassword,
      }),
    },
  ];
}

export function validateAccountSecurityForm(values) {
  const errors = {};
  const { currentPassword, newPassword, confirmPassword } = normalizeValues(values);

  if (currentPassword.length === 0) {
    errors.currentPassword = 'Ingresa tu contraseña actual.';
  }

  if (!newPassword) {
    errors.newPassword = 'Ingresa una nueva contraseña.';
  } else if (newPassword.length < MIN_PASSWORD_LENGTH) {
    errors.newPassword = `La nueva contraseña debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres.`;
  } else if (!hasMixedCase(newPassword)) {
    errors.newPassword = 'La nueva contraseña debe incluir mayúsculas y minúsculas.';
  } else if (!hasNumber(newPassword)) {
    errors.newPassword = 'La nueva contraseña debe incluir al menos un número.';
  } else if (!hasSpecialCharacter(newPassword)) {
    errors.newPassword = 'La nueva contraseña debe incluir al menos un carácter especial.';
  } else if (currentPassword && newPassword === currentPassword) {
    errors.newPassword = 'La nueva contraseña debe ser distinta a la actual.';
  } else if (newPassword.length > MAX_PASSWORD_LENGTH) {
    errors.newPassword = `La nueva contraseña no puede superar los ${MAX_PASSWORD_LENGTH} caracteres.`;
  }

  if (!confirmPassword) {
    errors.confirmPassword = 'Confirma la nueva contraseña.';
  } else if (newPassword !== confirmPassword) {
    errors.confirmPassword = 'Las contraseñas no coinciden.';
  }

  return errors;
}
